if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      const formData = new FormData(this.form);
      const formId = this.form.getAttribute('id');
      const potSelector = formId && document.getElementById(`pot-selector-${formId.replace('product-form-', '')}`);
      const pot = potSelector && potSelector.selectedPot;
      const sections = this.cartNotification.getSectionsToRender().map((section) => section.id);
      if (pot) {
        config.body = JSON.stringify(this.buildBundlePayload(formData, pot, sections));
      } else {
        delete config.headers['Content-Type'];
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          
          // Store the variant ID(s) that were just added for filtering
          const variantId = formData.get('id');
          if (variantId) {
            window.recentlyAddedItems = pot ? [String(pot.id), String(variantId)] : [String(variantId)];
          }
          
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }
    
    // The plant with its own line properties, then the pot as a nested cart line under it:
    // parent_id is the plant's variant id in this same request. Shopify then groups the pair in
    // cart, checkout and the order, and drops the pot if the plant is removed. JSON because that is
    // the documented shape for parent_id. _paired_plant stays for snippets/hp-unpaired-plants.liquid.
    buildBundlePayload(formData, pot, sections) {
      const plantId = Number(formData.get('id'));
      const plant = { id: plantId, quantity: Number(formData.get('quantity')) || 1 };
      const properties = {};
      for (const [key, value] of formData.entries()) {
        const name = key.match(/^properties\[(.+)\]$/);
        if (name && typeof value === 'string') properties[name[1]] = value;
      }
      if (Object.keys(properties).length) plant.properties = properties;
      if (formData.get('selling_plan')) plant.selling_plan = Number(formData.get('selling_plan'));

      const potLine = { id: pot.id, quantity: 1, parent_id: plantId };
      if (pot.handle) potLine.properties = { _paired_plant: pot.handle };

      return { items: [plant, potLine], sections, sections_url: window.location.pathname };
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
